export const initialCareers = [
  {
    id: "job-1",
    slug: "senior-full-stack-engineer-react-node",
    title: "Senior Full-Stack Engineer (React & Node.js)",
    department: "Engineering",
    location: "Remote (Global) / Hybrid",
    employmentType: "Full-Time",
    experience: "5+ Years",
    salaryRange: "$95,000 - $140,000 / Year + Equity",
    shortDescription: "Lead the frontend and API architecture for enterprise SaaS client platforms using React, TypeScript, and Node.js microservices.",
    responsibilities: [
      "Architect and ship modular web applications with React, TypeScript, and Next.js",
      "Design high-throughput REST and GraphQL APIs backed by PostgreSQL and Redis",
      "Collaborate directly with founders and product managers during agile sprints",
      "Conduct code reviews and mentor junior engineering team members",
      "Ensure 90%+ automated test coverage across unit and integration tests"
    ],
    requirements: [
      "5+ years of production experience with modern React, TypeScript, and Node.js",
      "Deep understanding of state management (Redux Toolkit / RTK Query) and SSR",
      "Solid foundation in relational database design (PostgreSQL) and query optimization",
      "Experience deploying containerized Docker applications on AWS",
      "Strong communication skills for asynchronous remote collaboration"
    ],
    niceToHave: [
      "Experience with Python / FastAPI and LLM integration",
      "Open-source contributions to developer tooling or libraries",
      "Familiarity with WebRTC and WebSocket real-time systems"
    ],
    benefits: [
      "100% remote-first work environment with flexible working hours",
      "Annual tech equipment stipend ($2,500 workstation budget)",
      "Comprehensive health, dental, and vision insurance coverage",
      "Unlimited paid time off (PTO) with mandatory minimum holidays",
      "Annual learning and conference budget ($1,500/year)"
    ]
  },
  {
    id: "job-2",
    slug: "senior-ai-ml-engineer-python-rag",
    title: "Senior AI / Machine Learning Engineer (LLMs & RAG)",
    department: "AI & Data Science",
    location: "Remote (Global)",
    employmentType: "Full-Time",
    experience: "4+ Years",
    salaryRange: "$110,000 - $160,000 / Year + Equity",
    shortDescription: "Build production-ready LLM applications, RAG pipelines, autonomous agent architectures, and custom fine-tuning pipelines.",
    responsibilities: [
      "Engineer low-latency RAG retrieval pipelines using Pinecone, Qdrant, and hybrid search",
      "Implement multi-agent workflow orchestration using LangChain, LlamaIndex, and AutoGen",
      "Develop high-speed microservices in Python with FastAPI and Docker",
      "Establish observability, token optimization, and guardrail monitoring for AI systems",
      "Fine-tune open-source models (Llama 3, Mistral) for specific client domain datasets"
    ],
    requirements: [
      "4+ years of Python engineering with deep focus on NLP, PyTorch, and Transformer models",
      "Demonstrated production experience building RAG architectures and vector databases",
      "Strong proficiency with FastAPI, asynchronous IO, and containerized deployment",
      "Knowledge of LLM benchmarking, evaluation metrics, and hallucination reduction"
    ],
    niceToHave: [
      "Experience with n8n workflow automation and MCP server integrations",
      "Published research or open-source AI repos with high community adoption"
    ],
    benefits: [
      "100% remote-first work flexibility across any timezone",
      "Access to dedicated GPU compute clusters (H100 / A100 instances)",
      "Comprehensive international health and wellness stipend",
      "Generous equity stock options",
      "Paid attendance at top AI conferences (NeurIPS, ICML, CVPR)"
    ]
  },
  {
    id: "job-3",
    slug: "senior-devops-cloud-architect",
    title: "Senior Cloud & DevOps Architect (AWS / Kubernetes)",
    department: "Infrastructure",
    location: "Remote (Global)",
    employmentType: "Full-Time",
    experience: "5+ Years",
    salaryRange: "$100,000 - $150,000 / Year",
    shortDescription: "Design, automate, and maintain resilient multi-region cloud infrastructure using Terraform, Kubernetes, and AWS.",
    responsibilities: [
      "Build declarative Infrastructure as Code using Terraform and Terragrunt",
      "Manage production Kubernetes clusters (EKS/GKE) with Helm and ArgoCD",
      "Implement zero-downtime CI/CD deployment pipelines using GitHub Actions",
      "Maintain 24/7 observability, Prometheus metrics, and automated alert routing",
      "Conduct regular security posture assessments and disaster recovery drills"
    ],
    requirements: [
      "5+ years architecting enterprise AWS or Google Cloud infrastructure",
      "Deep hands-on experience with Kubernetes, Docker, and service meshes",
      "Strong scripting capabilities in Bash, Python, or Go",
      "Experience managing high-availability PostgreSQL clusters and Redis caches"
    ],
    niceToHave: [
      "AWS Certified Solutions Architect Professional certification",
      "Experience with SOC 2 / HIPAA compliance automation"
    ],
    benefits: [
      "100% remote flexibility with home office setup allowance",
      "Premium health insurance",
      "Competitive annual performance bonuses",
      "Continuous certification and learning sponsorship"
    ]
  }
];
